import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicantRedirectableName",
  props: {
    linkedProfiles: {
      type: Array,
      default: null
    },
    applicantName: {
      type: String,
      required: true
    }
  },
  computed: {
    fullName() {
      const {
        givenName,
        familyName
      } = this.onlyOneLinkedProfile;
      return `${givenName} ${familyName}`;
    },
    onlyOneLinkedTooltip() {
      return `${this.$t("application.seeLinkedClientProfile")} (${this.fullName})`;
    },
    onlyOneLinkedProfile() {
      return this.linkedProfiles.length === 1 && this.linkedProfiles[0];
    }
  },
  activated() {
    this.$nextTick(() => {
      var _context;
      return _findInstanceProperty(_context = $(this.$el)).call(_context, "tooltip").tooltip();
    });
  },
  deactivated() {
    this.destroyTooltip();
  },
  methods: {
    redirectLink(linkedProfile) {
      const {
        boardId,
        clientProfileId
      } = linkedProfile;
      return {
        name: "client-profile",
        params: {
          clientProfileId,
          boardId
        }
      };
    },
    handleDropdownAnchor(linkedProfile) {
      window.location.href = this.redirectLink(linkedProfile);
    },
    formatMoneyValue(value) {
      return this.$options.filters.formatMoneyValue(value);
    },
    destroyTooltip() {
      $(".tooltip").tooltip("hide");
    }
  }
});